import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

const map = new WeakMap<HTMLElement, any>();

function initNavigation(container: HTMLElement | null) {
    if (container)
        container.innerHTML = `
    <div class="gallery-ctrl">
        <button class="js-gallery-btn-prev button button__round button__round--gray slider-btn slider-btn--prev" aria-label="предыдущий слайд">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3334 1.3335L6.00008 6.00016L1.66675 1.3335" stroke="#1F1F22" stroke-width="1.5" stroke-linecap="square"/>
            </svg>
        </button>
        <button class="js-gallery-btn-next button button__round button__round--gray slider-btn slider-btn--next" aria-label="следующий слайд">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3334 1.3335L6.00008 6.00016L1.66675 1.3335" stroke="#1F1F22" stroke-width="1.5" stroke-linecap="square"/>
            </svg>
        </button>
    </div>
    `;
}

function init(container: HTMLElement | Document = document) {
    const arrSlider = container.querySelectorAll<HTMLElement>('.js-gallery-material-slider');

    arrSlider.forEach((slider) => {
        const navigation = slider.querySelector<HTMLElement>('.js-gallery-navigation');
        if (navigation) initNavigation(navigation);

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            spaceBetween: 16,
            navigation: {
                nextEl: '.js-gallery-btn-next',
                prevEl: '.js-gallery-btn-prev',
                disabledClass: 'is-disabled',
            },
            breakpoints: {
                1025: {
                    spaceBetween: 20,
                    slidesPerView: 1.42,
                },
            },
        });

        map.set(slider, swiper);
    });
}

function destroy(container: HTMLElement | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>('.js-gallery-material-slider')).forEach((el) => {
        const slider = map.get(el);

        if (slider) {
            slider.destroy();
            map.delete(el);
        }
    });
}

const _module = { init, destroy };

export default _module;
